import React from 'react';
import { Card, Descriptions, Tag } from 'antd';
import { formatCPF, formatCNPJ } from '../../../../utils/format-cpfcnpj';
import * as MoneyFormater from '../../../../utils/MoneyFormater';
import './styles.css';

const DevedorInfo = ({ devedor }) => {
  if (!devedor) return null;

  const formatDocument = (doc) => {
    if (!doc) return '-';
    return doc.length === 11 ? formatCPF(doc) : formatCNPJ(doc);
  };

  // Calcular totais
  const totalContratos = (devedor.operacao_set && devedor.operacao_set.length) || 0;
  const somaParcelas = (devedor.operacao_set && devedor.operacao_set.reduce((sum, op) => {
    const parcelas = op.parcela_set || [];
    return sum + parcelas.reduce((s, p) => s + (parseFloat(p.valor_parcela) || 0), 0);
  }, 0)) || 0;

  return (
    <Card className="devedor-info__card">
      <div className="devedor-info__header">
        <div>
          <h3 className="devedor-info__nome">{devedor.nome}</h3>
          <Tag color="blue">{devedor.pf_pj === 'PF' ? 'Pessoa Física' : 'Pessoa Jurídica'}</Tag>
        </div>
        <div className="devedor-info__stats">
          <div className="devedor-info__stat">
            <span className="devedor-info__stat-label">Contratos</span>
            <span className="devedor-info__stat-value">{totalContratos}</span>
          </div>
          <div className="devedor-info__stat">
            <span className="devedor-info__stat-label">Soma Parcelas</span>
            <span className="devedor-info__stat-value">R$ {MoneyFormater.format(somaParcelas)}</span>
          </div>
        </div>
      </div>

      <Descriptions column={4} size="small" className="devedor-info__descriptions">
        <Descriptions.Item label="CPF/CNPJ">
          {formatDocument(devedor.cpf_cnpj)}
        </Descriptions.Item>
        <Descriptions.Item label="Data Cadastro">
          {devedor.dt_cadastro || '-'}
        </Descriptions.Item>
        <Descriptions.Item label="Data Cadastro TXT">
          {devedor.dt_cadastro_txt || '-'}
        </Descriptions.Item>
        <Descriptions.Item label="Contratos Ativos">
          {(devedor.operacao_set && devedor.operacao_set.filter(op => !op.is_deleted).length) || 0}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default DevedorInfo;



// WEBPACK FOOTER //
// ./src/pages/Pasta/Contratos/DevedorInfo/index.jsx